import React from 'react';
import ReactDOM from 'react-dom';

/* se pueden borrar */
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

/*Redux*/
import { Provider } from 'react-redux';
import store from './redux/store';

import barquito from "./Imagenes/barco-pirata.png"




import { BrowserRouter} from 'react-router-dom';

ReactDOM.render(
  <Provider store={store}>

  <BrowserRouter>
  <React.StrictMode>
    <img src={barquito} alt="barquito" class="element"/>
    <App />
  </React.StrictMode>
  </BrowserRouter>

  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
